export default class SimpleSlider {
    constructor(container) {
        this.wrapper = container;
        this.cards = this.wrapper.querySelectorAll('[data-id="cards"]');
        this.dotsContainer = this.wrapper.parentElement.querySelector('[data-id="dots"]');

        if (!this.wrapper || !this.cards.length || !this.dotsContainer) return;

        this.currentIndex = 0;
        this.initDots();
        this.addListeners();
    }
    initDots() {
        this.dotsContainer.innerHTML = '';
        this.cards.forEach((_, i) => {
            const dot = document.createElement('button');
            dot.classList.add('slider-dot');
            if (i === 0) dot.classList.add('active');
            dot.addEventListener('click', () => this.scrollTo(i));
            this.dotsContainer.appendChild(dot);
        });
        this.dots = this.dotsContainer.querySelectorAll('.slider-dot');
    }

    addListeners() {
        this.wrapper.addEventListener('scroll', this.onScroll.bind(this));
    }

    onScroll() {
        const index = Math.round(this.wrapper.scrollLeft / this.wrapper.clientWidth);
        if (index !== this.currentIndex) {
            this.currentIndex = index;
            this.updateDots();
        }
    }

    updateDots() {
        this.dots.forEach((dot, i) => {
            dot.classList.toggle('active', i === this.currentIndex);
        });
    }

    scrollTo(index) {
        this.wrapper.scrollTo({
            left: index * this.wrapper.clientWidth,
            behavior: 'smooth',
        });
    }

    destroy() {
        this.wrapper.removeEventListener('scroll', this.scrollHandler);
        this.wrapper = null;
    }
}
